export enum DiscountCodesGenerationMode {
  Upload = 0,
  GenerateFixedList = 1,
  GenerateWhenNeeded = 2,
}
